// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-app {
  min-height: 100vh;
  /* background-color: #1a1a1a; */
  color: white;
  margin-left: 15%;
}

.location-main-content {
  display: flex;
  height: calc(100vh - 80px);
}


.location-scrollbar::-webkit-scrollbar {
  width: 8px;
}

.location-scrollbar::-webkit-scrollbar-track {
  background: #1a1a1a;
}

.location-scrollbar::-webkit-scrollbar-thumb {
  background: #65ccb7;
  border-radius: 4px;
}

.location-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #4fa796;
}

.location-mapboxgl-ctrl-logo {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/globe/LocationSearch.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".location-app {\n  min-height: 100vh;\n  /* background-color: #1a1a1a; */\n  color: white;\n  margin-left: 15%;\n}\n\n.location-main-content {\n  display: flex;\n  height: calc(100vh - 80px);\n}\n\n\n.location-scrollbar::-webkit-scrollbar {\n  width: 8px;\n}\n\n.location-scrollbar::-webkit-scrollbar-track {\n  background: #1a1a1a;\n}\n\n.location-scrollbar::-webkit-scrollbar-thumb {\n  background: #65ccb7;\n  border-radius: 4px;\n}\n\n.location-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #4fa796;\n}\n\n.location-mapboxgl-ctrl-logo {\n  display: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
